import { Component, ChangeDetectionStrategy, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { PressReleaseCardItem, PressReleaseSection } from '@modules/content-api/adapter/magazine.adapter';
import {
  ActionIcons,
  ButtonItem,
  ActionContainerComponent,
} from '@modules/ui/action-container/action-container.component';
import { MetaItemsComponent } from '@modules/ui/meta-items/meta-items.component';

import { ImageComponent } from '../../media/image/image.component';
import { LocalizedDatePipe } from '../../pipes/localized-date.pipe';
import { SectionDefaultsComponent } from '../section-defaults';

@Component({
  selector: 'mb-press-release-section',
  templateUrl: './press-release-section.component.html',
  styleUrls: ['./press-release-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, RouterLink, ActionContainerComponent, LocalizedDatePipe, TranslatePipe, MetaItemsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PressReleaseSectionComponent extends SectionDefaultsComponent {
  public defaultActions: ButtonItem[] = [
    {
      icon: ActionIcons.SHARE,
      class: 'btn btn-plain d-none d-sm-inline-flex',
    },
    {
      icon: ActionIcons.DOWNLOAD,
      class: 'btn btn-plain d-none d-sm-inline-flex',
    },
    {
      icon: ActionIcons.BOOKMARK,
      class: 'btn btn-plain',
    },
  ];

  public cardTagConfig: Record<PressReleaseCardItem['cardType'], { icon: string; label: string }> = {
    article: { icon: 'bds/layers/16', label: 'PRESS_INFORMATION' },
    presskit: { icon: 'bds/layers/16', label: 'PRESS_KIT' },
  };

  @Input() pressReleaseSection!: PressReleaseSection;
}
